/** Sufijo de ruta tras `{storeId}/`, ej. `total-sales` o `cyd/total-qty` */
export function getMetricPathFromEndpoint(apiEndpoint: string | undefined): string {
  if (!apiEndpoint) {
    return '';
  }
  return apiEndpoint.replace('/api/metrics/{storeId}/', '');
}